import React from 'react';
import { cn } from '../../lib/utils';

/**
 * Composant de sélection multiple avec badges cliquables
 */
export function MultiSelectBadges({
  options,
  selected = [],
  onChange,
  label,
  description,
  maxSelect,
  className
}) {
  const handleToggle = (value) => {
    if (selected.includes(value)) {
      onChange(selected.filter(v => v !== value));
    } else {
      if (maxSelect && selected.length >= maxSelect) {
        // Remplacer le premier élément si max atteint
        onChange([...selected.slice(1), value]);
      } else {
        onChange([...selected, value]);
      }
    }
  };

  return (
    <div className={cn("space-y-2", className)}>
      {label && (
        <div>
          <label className="text-sm font-medium text-gray-700">{label}</label>
          {description && (
            <p className="text-xs text-gray-500">{description}</p>
          )}
        </div>
      )}
      <div className="flex flex-wrap gap-2">
        {options.map((option) => {
          const isSelected = selected.includes(option.value);
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => handleToggle(option.value)}
              className={cn(
                "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium transition-all",
                "border-2 hover:scale-105",
                isSelected
                  ? "bg-orange-100 border-orange-500 text-orange-700"
                  : "bg-gray-50 border-gray-200 text-gray-600 hover:border-gray-300"
              )}
            >
              {option.icon && <span>{option.icon}</span>}
              <span>{option.label}</span>
            </button>
          );
        })}
      </div>
      {maxSelect && (
        <p className="text-xs text-gray-400">
          {selected.length}/{maxSelect} sélectionnés
        </p>
      )}
    </div>
  );
}

/**
 * Composant de sélection unique avec badges
 */
export function SingleSelectBadges({
  options,
  selected,
  onChange,
  label,
  description,
  className
}) {
  return (
    <div className={cn("space-y-2", className)}>
      {label && (
        <div>
          <label className="text-sm font-medium text-gray-700">{label}</label>
          {description && (
            <p className="text-xs text-gray-500">{description}</p>
          )}
        </div>
      )}
      <div className="flex flex-wrap gap-2">
        {options.map((option) => {
          const isSelected = selected === option.value;
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => onChange(option.value)}
              className={cn(
                "inline-flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium transition-all",
                "border-2 hover:scale-105",
                isSelected
                  ? "bg-orange-100 border-orange-500 text-orange-700"
                  : "bg-gray-50 border-gray-200 text-gray-600 hover:border-gray-300"
              )}
            >
              {option.icon && <span className="text-lg">{option.icon}</span>}
              <div className="text-left">
                <span className="block">{option.label}</span>
                {option.description && (
                  <span className="block text-xs opacity-70">{option.description}</span>
                )}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default MultiSelectBadges;
